import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Configuration} from "../config/config";

@Injectable()
export class PortalReportsService {
  public jwtToken: string;
  constructor(private http: HttpClient) {
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

  refreshToken(){
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

  gamePortalReport(data){


    return this.http.post(Configuration.ServerWithApiUrl+ '/gamePortalReport',data)
      .map((res: any)=>res)
  }

  getLeaderBoard(comm_id){


    return this.http.get(Configuration.ServerWithApiUrl+'/leader_board/'+comm_id)
      .map((res: any)=>res)
  }

  getAllCommunities(){


    return this.http.get(Configuration.ServerWithApiUrl+'/communitiesnames')
      .map((res: any)=>res)
  }

  getCommunityByName(name){


    return this.http.get(Configuration.ServerWithApiUrl+ '/getCommunityByName/'+name)
      .map((res: any)=>res)
  }

  compareCommunityAccessWithUniverse(data){


    return this.http.post(Configuration.ServerWithApiUrl+ '/compareCommunityAccessWithUniverse',data)
      .map((res: any)=>res)
  }

  compareCommunityPerformanceWithUniverse(data){


    return this.http.post(Configuration.ServerWithApiUrl+ '/compareCommunityPerformanceWithUniverse',data)
      .map((res: any)=>res)
  }

  compareCommunityCertificationWithUniverse(data){


    return this.http.post(Configuration.ServerWithApiUrl+ '/compareCommunityCertificationWithUniverse',data)
      .map((res: any)=>res)
  }
  compareCommunityJourneyWithUniverse(data){
    return this.http.post(Configuration.ServerWithApiUrl+ '/compareCommunityJourneyWithUniverse',data)
      .map((res: any)=>res)
  }
  compareCommunityGameResponseWithUniverse(data){


    return this.http.post(Configuration.ServerWithApiUrl+ '/compareCommunityGameResponseWithUniverse',data)
      .map((res: any)=>res)
  }

  getPortalCentricStats(){


    return this.http.get(Configuration.ServerWithApiUrl+ '/portalCentricStats')
      .map((res: any)=>res)
  }

  getSubscriptionStats(){


    return this.http.get(Configuration.ServerWithApiUrl+'/portalSubscriptionStatus')
      .map((res: any)=>res)
  }

  getAllModules(){


    return this.http.get(Configuration.ServerWithApiUrl+'/getAllCoursesToAssignCommunity' )
      .map((res: any)=>res)
  }

  getAllCertificates(){


    return this.http.get(Configuration.ServerWithApiUrl+'/getAllCertificatesToAssignCertificate' )
      .map((res: any)=>res)
  }

  moduleCertGame(id, flag){

    return this.http.get(Configuration.ServerWithApiUrl + '/moduleCertGame/' + id + '/' + flag)
      .map((res: any)=>res)
  }
  getAllCommunityGames(){

    return this.http.get(Configuration.ServerWithApiUrl + '/game')
      .map((res: any)=>res)
  }
  getAllCommunityCertification(){

    return this.http.get(Configuration.ServerWithApiUrl + '/allCommunityCertificates')
      .map((res: any)=>res)
  }

  getAllCommunityJourney(){

    return this.http.get(Configuration.ServerWithApiUrl + '/allCommunityJourney')
      .map((res: any)=>res)
  }

  guestReport(data){


    return this.http.post(Configuration.ServerWithApiUrl+ '/guestReport',data)
      .map((res: any)=>res)
  }

  getAllGames(){

    return this.http.get(Configuration.ServerWithApiUrl + '/game')
      .map((res: any)=>res)
  }

  getAllJourneys(){


    return this.http.get(Configuration.ServerWithApiUrl+'/getAllJourneys' )
      .map((res: any)=>res)
  }

  getUserLoginFailedAttempsReprot(data){


    return this.http.post(Configuration.ServerWithApiUrl+ '/getUserLoginFailedAttempsReprot',data)
      .map((res: any)=>res)
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/portal-reports.service.ts